import { _api_getCarts } from "../api/index.js"
import { dataTranslations as dt, currencyMap, notificationErrors } from "./index.js"

const setCustomEvent = (name) => {
  // console.debug("setCustomEvent: ", name)
  window.dispatchEvent(new CustomEvent(name+'-localstorage-changed', {
    detail: {
      storage: localStorage.getItem(name)
    }
  }));
}
export const assignCartCount = (force = false) => {
  let cartCount = localStorage.getItem('CART_COUNT')
  if (cartCount == null) {
    force = true
  }
  // console.debug("assignCartCount: ", force)
  if (force) {
	  _api_getCarts()
		.then(async (res) => {
			const cartCount = res?.count
			if (cartCount) {
        $('#cartCount').text(cartCount);
        localStorage.setItem('CART_COUNT', cartCount);
      } else {
        $('#cartCount').text(0);
        localStorage.setItem('CART_COUNT', 0);
      }
      setCustomEvent("CART_COUNT");
      // console.debug("cartCount: ", localStorage.getItem('CART_COUNT'))
		})
		.catch((error) => {
			console.debug("assignCartCount Fail: ", error)
		})
  } else {
    $('#cartCount').text(cartCount);
    setCustomEvent("CART_COUNT");
  }
}

export const clearCartCount = () => {
	localStorage.removeItem('CART_COUNT')
}

export const getAssorts = (item, currency = "TWD") => {
  let tmpAssorts = [];
  // console.log("getAssorts: ", item);
  if (!item?.assorts) {
    return tmpAssorts
  }
  item.assorts.forEach((assort) => {
      let data = {
          ...assort,
          store_assort_id: assort?.id,
          store_assort_name: dt(assort?.name_translations),
          store_product_id: item?.id,
          store_product_name: dt(item?.name_translations),
          buy_qty: 0,
          max_order_quantity: assort?.max_order_quantity || 20,
          symbol: currencyMap(currency).symbol,
          comm_price: assort?.comm_price ? assort?.comm_price : assort?.comm_price_currencies?.[currency] || 0,
          sale_price: assort?.sale_price ? assort?.sale_price : assort?.sale_price_currencies?.[currency] || 0,
          addon_price: assort?.addon_price ? assort?.addon_price : assort?.addon_price_currencies?.[currency] || 0,
          discounted_price: assort?.discounted_price ? assort?.discounted_price : assort?.discounted_price_currencies?.[currency] || 0,
      };
      tmpAssorts.push(data)
  })
  return tmpAssorts
}
export const addToCartSuccess = () => {
  toastr.success("成功加入購物車", {
    closeButton: true,
    progressBar: true,
    positionClass: 'toast-top-right',
  });
  return
  swal.fire({
      title: '成功加入購物車',
      type: 'success',
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonColor: 'var(--secondary_color)',
      confirmButtonText: t("carts.continueShopping2"),
      cancelButtonColor: 'var(--primary_color)',
      cancelButtonText: '直接結帳',
  }).then((result) => {
      // console.log('result', result);
      if (result.value) {
          // console.log('繼續購物');
      } else if (result.dismiss == "cancel") {
          // console.log('直接結帳');
          window.location.href = "/checkout";
      }
  })
}

export const checkBuyQty = (assorts) => {
    let items = [];
    assorts.forEach((assort) => {
        if (assort.buy_qty) {
            items.push({
                store_product_id: assort.store_product_id,
                store_assort_id: assort.store_assort_id,
                quantity: assort.buy_qty,
                prod_name: dt(assort?.name_translations),
                prod_assort_name: dt(assort?.name_translations),
                price: assort?.discounted_price || assort?.sale_price,
            })
        }
    });
    return items;
}
